// import 'preact/debug'; // Only for preact debugging

// Add polyfills for Chromium 38. This import is unconditional, but a webpack plugin replaces
// '##/overrides/chrome38' with an empty module at build time for non-legacy Chrome targets.
import '##/overrides/chrome38';
import { init as keyInit } from '@accedo/virtual-key';
// Include the next 2 imports if you are using Open Telemetry and service features
import { APP_PLATFORM, APP_NAME, APP_VERSION } from '##/env';
// If using New Relic or other Observability service will need to add setup here
import App from './App';
import './styles/index.scss';

const appInfo = {
  appName: APP_NAME,
  appVersion: APP_VERSION,
  appPlatform: APP_PLATFORM,
};

console.log('[index] Starting app with info:', appInfo);

// Needed for some Tizen TVs that do not have AbortController implemented
if (typeof window.AbortController === 'undefined') {
  // @ts-expect-error no types for this polyfill
  import('abortcontroller-polyfill/dist/abortcontroller-polyfill-only')
    .then(() => {
      console.log('[index] AbortController polyfill loaded');
    })
    .catch((err) => {
      console.error('[index] Failed to load AbortController polyfill', err);
    });
}

// Initialize Virtual Key Service
keyInit();

// Example of setting up a service worker or other service on app start
// if (SERVICE_ENABLED) {
//   try {
//     setupService();
//   } catch (error) {
//     console.error('[index] Error setting up Service:', error);
//   }
// }

// If you need to register a service worker manually you can do it here.
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register(`${PUBLIC_PATH}service-worker.js`)
//     .then((registration) => {
//       console.log('Service Worker registered with scope:', registration.scope);
//     })
//     .catch((error) => {
//       console.error('Service Worker registration failed:', error);
//     });
// }

export default App;
